import React, { useState, useCallback } from 'react';
import OtpInput from 'react-otp-input';
import PropTypes from 'prop-types';
import Button from 'partial/components/Button';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import { useVerifyMfaOtp } from '../hooks';

export const useConfirmMfaOtp = () => {
  const createModal = useCreateModal();

  const openConfirmMfaOtpModal = useCallback(
    (email) => {
      createModal({
        content: (close) => <ConfirmMfaOtp onClose={close} email={email} />,
      });
    },
    [createModal],
  );

  return openConfirmMfaOtpModal;
};

function ConfirmMfaOtp({ onClose, email }) {
  const [state, setState] = useState({ otp: '' });
  const [error, setError] = useState('');
  const [isLoading, verify] = useVerifyMfaOtp(onClose, (err) => setError(err));

  const handleSubmit = (e) => {
    e.preventDefault();
    verify({ email, otp: state.otp });
  };

  const handleChange = (val) => {
    setState((prev) => ({ ...prev, otp: val }));
  };

  return (
    <ModalCard size="sm" onClose={onClose}>
      <div className="px-8 pb-8 max-h-[90vh] overflow-y-auto">
        <form onSubmit={handleSubmit}>
          <div className="flex flex-col items-center">
            <div className="text-lg font-bold text-gray-700 mt-2 mb-6">
              PIN VERIFICATION
            </div>
            <div className="font-semibold text-gray-500 mb-3">
              <span>Enter the 6 digit PIN from your </span>
              <span className="font-bold text-gray-700">authenticator app</span>
            </div>
            <OtpInput
              inputType="tel"
              containerStyle="w-full gap-4 sm:px-10"
              value={state?.otp}
              onChange={handleChange}
              numInputs={6}
              renderInput={(props) => (
                <input
                  {...props}
                  className="text-gray-700 font-bold text-lg flex-1 rounded border border-light-gray-300 !w-full h-8 sm:h-14"
                />
              )}
            />
          </div>
          {error && (
            <div className="rounded bg-danger-300 text-white px-4 py-1 my-4 mx-4">
              {error}
            </div>
          )}
          <div className="px-4 mt-4">
            <Button
              type="submit"
              primary
              className="w-full uppercase"
              size="xl"
              disabled={isLoading}
            >
              verify
            </Button>
          </div>
        </form>
      </div>
    </ModalCard>
  );
}

ConfirmMfaOtp.propTypes = {
  onClose: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
};

export default ConfirmMfaOtp;
